<template>
  <div class="edit-finished-auction">
    <div v-if="anyErrors" class="error-message">
      {{ error }}
    </div>
    <h5>
      {{ I18n.t("employees.results.auctions_catalogs.artworks.form.headers.state") }}
    </h5>
    <div class="sale-options">
      <div>
        <label>
          <input type="radio" :value="unsoldState" v-model="auctionState"/>
          {{ I18n.t("employees.results.auctions_catalogs.artworks.form.sale_options.unsold") }}
        </label>
      </div>
      <div>
        <label>
          <input type="radio" :value="soldState" v-model="auctionState"/>
          {{ I18n.t("employees.results.auctions_catalogs.artworks.form.sale_options.sold") }}
        </label>
      </div>
      <div>
        <label>
          <input type="radio" :value="soldConditionallyState" v-model="auctionState"/>
          {{ I18n.t("employees.results.auctions_catalogs.artworks.form.sale_options.sold_conditionally") }}
        </label>
      </div>
    </div>
    <h5 v-if="artworkSold">
      {{ I18n.t("employees.results.auctions_catalogs.artworks.form.headers.details") }}
    </h5>
    <div v-if="artworkSold" class="artwork-sold">
      <div>
        <label>
          {{ I18n.t("employees.results.auctions_catalogs.artworks.form.price") }}
          <input type="number" v-model="auctionValue" class="editValue"/>
            {{I18n.t("artworks.currency")}}
        </label>
      </div>
      <div class="sale-type">
        <div>
          <div>
            <label>
              <input type="radio" :value="bidAudience" v-model="auctionBidType"/>
              {{ I18n.t("employees.results.auctions_catalogs.artworks.form.bid_types.audience") }}
            </label>
          </div>
          <div>
            <label>
              <input type="radio" :value="bidPhone" v-model="auctionBidType"/>
              {{ I18n.t("employees.results.auctions_catalogs.artworks.form.bid_types.phone") }}
            </label>
          </div>
          <div>
            <label>
              <input type="radio" :value="bidAPP" v-model="auctionBidType"/>
              {{ I18n.t("employees.results.auctions_catalogs.artworks.form.bid_types.internet") }}
            </label>
          </div>
        </div>
      </div>
      <div v-if="shouldHaveWinner">
        {{ I18n.t("employees.results.auctions_catalogs.artworks.form.winner") }}
        <span v-if="hasWinnerAssigned">
          {{ winner.firstname }} {{ winner.lastname }}
        </span>
        <div class="winnerSelect d-inline-block">
          <EditAuctionWinner
            :auctionsCatalogId="auctionsCatalog.id"
            :auctionId="auction.id"
            :winnerAssigned="hasWinnerAssigned"
            v-on:update-winner="assignNewWinner"/>
        </div>
      </div>
    </div>
    <div v-if="negotiationsEnded"
         class="error-message"
         v-html="I18n.t('employees.results.auctions_catalogs.artworks.form.negotiations_ended_message')"
    >
    </div>
    <div class="submitSection">
      <input type="submit" :disabled="!isValid()"
             :value="I18n.t('simple_form.submit')" class="btn btn__default"
             v-on:click="put()">
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import { UNSOLD_STATE, SOLD_STATE, SOLD_CONDITIONALLY_STATE, BID_APP, BID_PHONE, BID_AUDIENCE } from './../../../consts';
  import EditAuctionWinner from './../edit_auction_winner';

  export default {
    name: 'Form',
    data() {
      return {
        auctionState: this.auction.state,
        auctionValue: this.auction.value,
        auctionBidType: this.auction.lastBidType,
        winner: {},
        error: null,
        requestIsPending: false,
        bidPhone: BID_PHONE,
        bidAPP: BID_APP,
        bidAudience: BID_AUDIENCE,
        soldState: SOLD_STATE,
        unsoldState: UNSOLD_STATE,
        soldConditionallyState: SOLD_CONDITIONALLY_STATE,
      };
    },
    props: {
      auction: {
        type: Object,
        required: true,
      },
      auctionsCatalog: {
        type: Object,
        required: true,
      },
    },
    created() {
      this.assignWinner();
      this.oldAuctionState = this.auction.state;
    },
    computed: {
      artworkSold() {
        return this.auctionState !== UNSOLD_STATE;
      },
      shouldHaveWinner() {
        return this.auctionBidType === BID_APP || this.auctionBidType === BID_PHONE;
      },
      hasWinnerAssigned() {
        return !(Object.keys(this.winner).length === 0);
      },
      valueIsGreaterThanZero() {
        return this.auctionValue > 0;
      },
      typeIsNotSelected() {
        return this.auctionBidType == null;
      },
      winnerId() {
        if (Object.prototype.hasOwnProperty.call(this, 'winner')) {
          return parseInt(this.winner.id, 10);
        }
        return null;
      },
      anyErrors() {
        return this.error != null;
      },
      negotiationsEnded() {
        return this.oldAuctionState === SOLD_CONDITIONALLY_STATE &&
               this.auctionState === SOLD_STATE &&
               this.shouldHaveWinner &&
               this.hasWinnerAssigned;
      },
    },
    components: {
      EditAuctionWinner,
    },
    methods: {
      ...mapActions('artworks', ['updateAuction']),
      put() {
        const auctionType = this.$route.params.auctionType.concat('_auction');
        this.prepareParamsToSend();
        const params = {
          [auctionType]: {
            state: this.auctionState,
            value: parseInt(this.auctionValue, 10),
            last_bid_type: this.auctionBidType,
            winner_id: this.winnerId,
          },
        };
        this.requestIsPending = true;
        this.error = null;
        this.updateAuction(
          [this.$route.params.auctionType, this.auctionsCatalog.id, this.auction.id, params],
        ).then(() => {
          this.$emit('close-edit-modal');
        }).catch((error) => {
          this.error = error.data.errors[0].detail;
          this.requestIsPending = false;
        });
      },
      assignNewWinner(newWinner) {
        if (Object.keys(newWinner).length === 0) {
          this.winner = {};
        } else {
          this.winner = Object.assign({}, newWinner);
        }
      },
      assignWinner() {
        if (Object.prototype.hasOwnProperty.call(this.auction, 'winner')) {
          Object.assign(this.winner, this.auction.winner);
        } else {
          this.winner = {};
        }
      },
      isValid() {
        if (this.artworkSold) {
          if (!this.valueIsGreaterThanZero) {
            return false;
          }
          if (this.typeIsNotSelected) {
            return false;
          }
          if (this.shouldHaveWinner) {
            if (!this.hasWinnerAssigned) {
              return false;
            }
          }
        }
        if (this.requestIsPending) {
          return false;
        }
        return true;
      },
      prepareParamsToSend() {
        if (!this.artworkSold) {
          this.prepareParamsForUnsoldState();
        } else if (this.auctionBidType === BID_AUDIENCE) {
          this.setWinnerToEmptyObject();
        }
      },
      prepareParamsForUnsoldState() {
        this.auctionValue = 0;
        this.auctionBidType = null;
        this.winner = {};
      },
      setWinnerToEmptyObject() {
        this.winner = {};
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/employees/components/finished/artworks/form.vue?33598c3a